import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resultAuctions } from '../../../selectors/auctionsSelector'
import AuctionsList from './AuctionList'
import { changeStateProp, mergeStateProp } from '../../../actions/index'

const mapStateToProps = (state) => {
  return {
    auctions: resultAuctions({
      auctions: state.data.auctions
    }),
    locationStates: state.data.locationStates,
    filters: state.user.filters
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ changeStateProp, mergeStateProp }, dispatch)
}

const AuctionsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuctionsList)

export default AuctionsListContainer
